  
import { Plugin } from "@ckeditor/ckeditor5-core";

export default class EmojiMain extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'EmojiMain';
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;

		editor.plugins.get( 'Emoji' ).addItems( '😃 ' + t('Utter Access'),
            [
                { title: ':2cents:', uri: '/emoticons/2cents.gif' }, 
                { title: ':bow:', uri: '/emoticons/acclaim.gif' }, 
                { title: ':applause:', uri: '/emoticons/applause.gif' }, 
                { title: ':btt:', uri: '/emoticons/backtotopic.gif' }, 
                { title: ':bg:', uri: '/emoticons/big_grin.gif' }, 
                { title: ':o:', uri: '/emoticons/blush.gif' }, 
                { title: ':o&#33:', uri: '/emoticons/cheers.gif' }, 
                { title: ':coffee:', uri: '/emoticons/coffee1.gif' }, 
                { title: ':compute:', uri: '/emoticons/compute.gif' }, 
                { title: ':confused:', uri: '/emoticons/confused.gif' }, 
                { title: ':cool:', uri: '/emoticons/cool.gif' }, 
                { title: ':crazy:', uri: '/emoticons/crazy.gif' }, 
                { title: ':bawl:', uri: '/emoticons/cryhard.gif' }, 
                { title: ':dance:', uri: '/emoticons/dance.gif' }, 
                { title: ':dazed:', uri: '/emoticons/dazed.gif' }, 
                { title: ':doh:', uri: '/emoticons/doh.gif' }, 
                { title: ':dunno:', uri: '/emoticons/dontknow.gif' }, 
                { title: ':dunce:', uri: '/emoticons/dunce.gif' }, 
                { title: ':evil:', uri: '/emoticons/evilgrin.gif' }, 
                { title: ':(', uri: '/emoticons/frown.gif' }, 
                { title: ':fundrink:', uri: '/emoticons/fundrink.gif' }, 
                { title: ':giveup:', uri: '/emoticons/giveup.gif' }, 
                { title: ':grin:', uri: '/emoticons/grin.gif' }, 
                { title: ':halo:', uri: '/emoticons/grinhalo.gif' }, 
                { title: ':beer:', uri: '/emoticons/guiness.gif' }, 
                { title: ':hattip:', uri: '/emoticons/hat_tip.gif' }, 
                { title: ':iconfused:', uri: '/emoticons/iconfused.gif' }, 
                { title: ':kiss:', uri: '/emoticons/kisses.gif' }, 
                { title: ':D', uri: '/emoticons/laugh.gif' }, 
                { title: ':lightbulb:', uri: '/emoticons/lightbulb.gif' }, 
                { title: ':like:', uri: '/emoticons/like.png' }, 
                { title: ':mad:', uri: '/emoticons/mad.gif' }, 
                { title: ':notworthy:', uri: '/emoticons/notworthy.gif' }, 
                { title: ':ohyeah:', uri: '/emoticons/ohyeah.gif' }, 
                { title: ':ooo:', uri: '/emoticons/ooo.gif' }, 
                { title: ':pompom:', uri: '/emoticons/pompom.gif' }, 
                { title: ':pullhair:', uri: '/emoticons/pullhair.gif' }, 
                { title: ':read:', uri: '/emoticons/reading.gif' }, 
                { title: ':lol:', uri: '/emoticons/rotflmao.gif' }, 
                { title: ':sad:', uri: '/emoticons/sad.gif' }, 
                { title: ':sarcasm:', uri: '/emoticons/sarcasm.gif' }, 
                { title: ':shocked:', uri: '/emoticons/shocked.gif' }, 
                { title: ':shrug:', uri: '/emoticons/shrug.gif' }, 
                { title: ':zzzz:', uri: '/emoticons/sleeping.gif' }, 
                { title: ':smirk:', uri: '/emoticons/smirk.gif' }, 
                { title: ':thanks:', uri: '/emoticons/thanks.gif' }, 
                { title: ':thumbdn:', uri: '/emoticons/thumbdn.gif' }, 
                { title: ':thumbup:', uri: '/emoticons/thumbup.gif' }, 
                { title: ':p', uri: '/emoticons/tongue.gif' }, 
                { title: ':uarulez:', uri: '/emoticons/uarulez2.gif' }, 
                { title: ':wary:', uri: '/emoticons/wary.gif' }, 
                { title: 'ho&#33;', uri: '/emoticons/wavehi.gif' }, 
                { title: ':welcome:', uri: '/emoticons/welcome2UA.gif' }, 
                { title: ':whew:', uri: '/emoticons/whew.gif' }, 
                { title: ':wine:', uri: '/emoticons/wine.gif' }, 
                { title: ';)', uri: '/emoticons/wink.gif' }, 
                { title: ':woohoo:', uri: '/emoticons/woohoo.gif' }, 
                { title: ':yay:', uri: '/emoticons/yayhandclap.gif' }, 
                { title: ':yw:', uri: '/emoticons/yw.gif' }, 
            ]
        );
	}
}